exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".j86BYy_k_fs0oACgIivi-{text-align:center}.j86BYy_k_fs0oACgIivi- h4{font-size:26px}.j86BYy_k_fs0oACgIivi- hr{width:80%;margin:1.2em auto}", ""]);

// exports
exports.locals = {
	"addFriends": "j86BYy_k_fs0oACgIivi-"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Friends/AddFriends.scss
 ** module id = 363
 ** module chunks = 0
 **/